import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { MEGA_WATT_CONVERSION_FACTOR } from "@/constants/common.constants";
import { getBaseUrl } from "@/helpers/fetch.helpers";
import { getJwtToken } from "@/helpers/storage.helpers";
import type {
  ScheduledResultantEnergyBlocksParams,
  ScheduledResultResultantEnergyBlocks,
  ScheduledResultResultantEnergyBlocksData,
} from "@/pages/Energy";

export const sourcesAllowed = ["energy_scheduling", "manual_input"];

export const resultantScheduledEnergyTransform = (response: {
  resultants: ScheduledResultResultantEnergyBlocksData[];
}): ScheduledResultResultantEnergyBlocks[] => {
  return response.resultants.map((item) => {
    return {
      from: item.start,
      to: item.end,
      volumeWh: item.wh,
      volumeMWh: item.wh / MEGA_WATT_CONVERSION_FACTOR,
    };
  });
};

export const energyScheduleExchangeApi = createApi({
  reducerPath: "energyScheduleExchangeApi",
  baseQuery: fetchBaseQuery({
    baseUrl: getBaseUrl("/schedule-exchange/"),
    prepareHeaders: (headers) => {
      headers.set("authorization", `Bearer ${getJwtToken()}`);
      return headers;
    },
  }),
  tagTypes: ["ScheduledResultantEnergyBlock"],
  endpoints: (build) => ({
    getScheduledResultants: build.query<
      ScheduledResultResultantEnergyBlocks[] | undefined,
      ScheduledResultantEnergyBlocksParams
    >({
      query: ({ deviceID, from, to }) => {
        return {
          url: "energy/schedules/resultant",
          params: {
            deviceID,
            start: from,
            end: to,
            source: sourcesAllowed.join(","),
          },
        };
      },
      transformResponse: resultantScheduledEnergyTransform,
      providesTags: ["ScheduledResultantEnergyBlock"],
    }),
  }),
});

export const { useGetScheduledResultantsQuery } = energyScheduleExchangeApi;
